import React from 'react'
import cx from 'classnames'

import { SidebarViewType } from 'apps/aiAutomation/lib/sidebar'

import { useViewKey } from './hooks/useViewKey'
import { useViewState } from './hooks/useViewState'

import cm from './styles.module.css'

interface SidebarViewProps {
  viewId: SidebarViewType
  children: React.ReactNode
}

export const SidebarView = ({ children, viewId }: SidebarViewProps) => {
  const {
    viewState,
    prevUniqueState,
    isInteractable,

    isVisible,

    wrapperRef,
  } = useViewState(viewId)

  const key = useViewKey(viewState)

  if (!isVisible) {
    return null
  }

  return (
    <div
      // @ts-expect-error type for inert is supported starting from React 19+
      // It's also not working for now when we pass true/false, that's why there is an empty string and undefined values
      inert={isInteractable ? undefined : ''}
      aria-hidden={!isInteractable}
      ref={wrapperRef}
      key={key}
      className={cx(cm.sidebarView, {
        [cm.enteringFromOut]: viewState === 'open' && prevUniqueState === 'closed',
        [cm.enteringFromIn]: viewState === 'open' && prevUniqueState === 'hidden',

        [cm.leavingToIn]: viewState === 'hidden' && prevUniqueState === 'open',
        [cm.leavingToOut]: viewState === 'closed' && prevUniqueState === 'open',

        [cm.sidebarView_interactable]: isInteractable,
      })}
      data-test-id={`ai-automation/sidebar-view-${viewId}`}
      {...(isInteractable ? { role: 'dialog', 'aria-modal': true } : {})}
    >
      {isVisible && children}
    </div>
  )
}
